export const CLASS_NAME = 'cst-centered-content-wrapper'
export const INNER_CLASS_NAME = 'cst-centered-content-wrapper-inner'
